import { formatCurrencyEnUs } from '@zorro/shared/formatters';
import { Flex, Text } from '@zorro/web/design-system';

type SimpleTooltipRowProps = {
  labelText: string;
  stipend: number;
  keyValue: string;
};

export const SimpleTooltipRow = ({
  labelText,
  stipend,
  keyValue,
}: SimpleTooltipRowProps) => {
  return (
    <Flex key={keyValue} justify="space-between" gap="3rem">
      <Text fz="xs">{labelText}</Text>
      <Text fz="xs">
        {formatCurrencyEnUs(stipend, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </Text>
    </Flex>
  );
};
